import { createContext } from "react";

export const ScreenLoaderContext = createContext({
    startLoader: null,
    stopLoader: null,
  });